<template>
  <div>
    <el-select
      v-if="companies.length > 1"
      v-model="_id"
      class="mr-3"
      placeholder="選擇經銷商"
      @change="onSelect"
    >
      <el-option
        v-for="item in companies"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>

    <div v-else>
      <h3>{{ companies[0].name }}</h3>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters('variable', ['companies', 'company_id']),
    _id: {
      get() {
        return this.company_id
      },
      set(val) {
        this.setCompanyId(val)
      }
    }
  },
  data() {
    return {
      loaded: false
    }
  },

  async created() {
    this._id = this.companies[0].id
    this.$emit('onSelect')
  },
  methods: {
    ...mapMutations('variable', ['setCompanyId']),
    onSelect() {
      this.$emit('onSelect')
    }
  }
}
</script>
